
export default function faceSelectedInitialise(listeFaces, facesSelectionne) {
  facesSelectionne.forEach((selectedItem) => {
    const face = listeFaces.find((el) => {
      return el.facNum === selectedItem.extensionOpportunite.faceSelectionne.facNum;
    });
    if (face) {
      face.selected = true;
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/catalogue/faceSelectedInitializer.js